var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 21.75H15.75",
    stroke: "#20C58B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3782 15.6562C6.48532 14.9619 5.76216 14.0735 5.26351 13.0583C4.76485 12.0432 4.50378 10.9278 4.50008 9.79678C4.48133 5.72803 7.7532 2.34366 11.822 2.24991C13.3966 2.21258 14.9431 2.67198 16.242 3.56294C17.541 4.45391 18.5264 5.73121 19.0586 7.21371C19.5908 8.6962 19.6428 10.3086 19.2071 11.8223C18.7714 13.336 17.8702 14.6741 16.6313 15.6468C16.3577 15.8583 16.136 16.1296 15.9832 16.44C15.8305 16.7503 15.7507 17.0915 15.7501 17.4374V17.9999C15.7501 18.1988 15.6711 18.3896 15.5304 18.5302C15.3898 18.6709 15.199 18.7499 15.0001 18.7499H9.00008C8.80117 18.7499 8.6104 18.6709 8.46975 18.5302C8.3291 18.3896 8.25008 18.1988 8.25008 17.9999V17.4374C8.24773 17.0941 8.16814 16.7557 8.01721 16.4474C7.86628 16.139 7.64788 15.8686 7.3782 15.6562V15.6562Z",
    stroke: "#20C58B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7598 5.32495C13.6764 5.48034 14.5223 5.91642 15.1805 6.57301C15.8388 7.2296 16.277 8.07431 16.4348 8.99058",
    stroke: "#20C58B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.a750ed8bb8ccea7fc5a8be283ed2e054.svg";
export { ForwardRef as ReactComponent };